import { useDeleteApiService, useGetApiService, usePatchApiService, usePostApiService } from '../use-api-service'
import { COMPANY_PATH } from '../constants'
import type {
  MessageResponse,
  GetCompanyResponse,
  CategoryPlanResponse,
  GetEmployeesRiskResponse,
} from '../types'
import type { DashboardStatsResponse } from '../types/company.types'
import type { VerifiedDomain, AddDomainPayload } from '../types/phishing.types'

export const useCompanyService = () => {
  const updateCompany = usePatchApiService<any, MessageResponse>(COMPANY_PATH)
  const toggleCategorySuggestion = usePatchApiService<any, MessageResponse>(COMPANY_PATH)
  const getCompany = useGetApiService<any, GetCompanyResponse>({ path: COMPANY_PATH, key: 'getCompany' })
  const getCategoryPlanByName = useGetApiService<any, CategoryPlanResponse>({
    path: COMPANY_PATH,
    key: 'getCategoryPlanByName',
  })
  const regenerateCategoryPlanByName = usePatchApiService<any, CategoryPlanResponse>(COMPANY_PATH)
  const getEmployeesRisk = useGetApiService<any, GetEmployeesRiskResponse>({
    path: COMPANY_PATH,
    key: 'getEmployeesRisk',
  })

  const getDashboardStats = useGetApiService<any, DashboardStatsResponse>({
    path: COMPANY_PATH,
    key: 'getDashboardStats',
  })

  // Domain Verification (with DNS TXT records)
  const getDomains = useGetApiService<any, { data: VerifiedDomain[]; message: string }>({
    path: COMPANY_PATH,
    key: 'getDomains',
  })
  const addDomain = usePostApiService<AddDomainPayload, { data: VerifiedDomain; message: string }>(COMPANY_PATH)
  const verifyDomain = usePostApiService<undefined, { data: VerifiedDomain; message: string }>(COMPANY_PATH)
  const deleteDomain = useDeleteApiService<any, { message: string }>(COMPANY_PATH)

  return {
    getCompany,
    updateCompany,
    getCategoryPlanByName,
    regenerateCategoryPlanByName,
    toggleCategorySuggestion,
    getEmployeesRisk,
    getDashboardStats,
    // Domain Verification
    getDomains,
    addDomain,
    verifyDomain,
    deleteDomain,
  }
}
